import{jsx as r}from"react/jsx-runtime";import{I18nextProvider as e}from"react-i18next";var i=({children:i,instance:n})=>r(e,{i18n:n,children:i});export{i as I18nProvider};
//# sourceMappingURL=I18nProvider.js.map